import axios from "axios";
const { API_BACKEND_HOST } = process.env;

interface IGetAllUsersParams {
  pageSize: number;
  page: number;
  name: string;
  groupId: string;
  role: string;
  external?: boolean;
};

export interface IMember {
  abbreviation: string;
  directoryName: string;
  email: string;
  groupId: string;
  groupName: string;
  id: string;
  name: string;
  position: string;
  external: boolean;
};

export interface IMemberByName {
  id: string;
  name: string;
  email: string;
  positionName: string;
  group: string;
};

export interface IMemberById {
  id: string,
  name: string,
  abbreviation: string,
  role: string,
  directoryId: string,
  directoryName: string,
  groups: [
    {
      id: string,
      name: string,
      committeePackageId: string,
      committeePackageName: string
    }
  ]
};

interface IGetAllUsersResponse {
  count: number;
  currentPage: number;
  members: IMember[];
  pageSize: number;
  totalPages: number;
};

export const getAll = async ({
  pageSize,
  page,
  name,
  groupId,
  role,
  external,
}: IGetAllUsersParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IGetAllUsersResponse>(
    `${API_BACKEND_HOST}${languageId}/v1/Members/all`,
    {
      params: {
        pageSize,
        page,
        name,
        groupId,
        role,
        ...(external !== undefined && { external }),
      },
      headers: {
        'ngrok-skip-browser-warning': true
      }
    }
  );

  return data;
};

export const getUserByName = async (name: string) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IMemberByName[]>(`${API_BACKEND_HOST}${languageId}/v1/Members?name=${name}`);

  return data;
};

export const getUserById = async (id: string) => {
  const languageId = localStorage.getItem("i18nextLng");

  const { data } = await axios.get<IMemberById>(`${API_BACKEND_HOST}${languageId}/v1/Members/${id}/groups`);

  return data;
};

interface ICreateUserParams {
  id: string;
  role: string;
  directoryId: string;
  groupId: string;
  abbreviation: string;
}

export const createUser = async (data: ICreateUserParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const response = await axios.post(
    `${API_BACKEND_HOST}${languageId}/v1/Members`,
    data
  );

  return response.data;
}

interface ICreateExternalUserParams {
  name: string;
  email: string;
  role?: string;
}

export const createExternalUser = async (data: ICreateExternalUserParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const response = await axios.post(
    `${API_BACKEND_HOST}${languageId}/v1/Members/external`,
    data
  );

  return response.data;
}

interface IUpdateUserParams {
  role: string;
  groupId: string;
  abbreviation: string;
}

export const updateUser = async (id: string, data: IUpdateUserParams) => {
  const languageId = localStorage.getItem("i18nextLng");

  const response = await axios.patch(
    `${API_BACKEND_HOST}${languageId}/v1/Members/${id}`,
    data
  );

  return response.data;
}